export default function BugFixingSection() {
    return (
      <section className="relative bg-[#0f1117] text-white py-20 px-6 md:px-12 lg:px-20 overflow-hidden">
        {/* Background pattern */}
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage:
              "url('/static/pattern-bg.svg')", // put your repeated icons image here
            backgroundRepeat: "no-repeat",
          }}
        ></div>
  
        {/* Content */}
        <div className="relative text-left max-w-5xl mx-auto">
          <h2 className="!text-3xl md:!text-[45px] !font-bold mb-6">
            Beyond Bug Fixing: Unlocking Player Intelligence
          </h2>
          <p className="text-[25px] text-[#9d9dbb] leading-relaxed">
            This isn't just about faster QA – it's about transforming every crash
            report into a window into your players' world. When developers can see
            the complete story behind each bug – the player's journey, their
            environment, their exact actions – they don't just fix issues faster,
            they build better games.
          </p>
        </div>
      </section>
    );
  }
  